import Events from '../../../enums/Events.js';
import triggerEvent from '../../../utilities/triggerEvent.js';
import { buildViewportFidelityState, viewportFidelityStateKey, } from './buildViewportFidelityState.js';
const lastKeys = new WeakMap();
export function notifyFidelityStateChanged(viewport, lines, displaySpacing) {
    const state = buildViewportFidelityState(lines, displaySpacing);
    const key = viewportFidelityStateKey(state);
    if (lastKeys.get(viewport) === key) {
        return;
    }
    lastKeys.set(viewport, key);
    if (viewport.suppressEvents) {
        return;
    }
    const eventDetail = {
        viewportId: viewport.id,
        renderingEngineId: viewport.renderingEngineId,
        state,
    };
    triggerEvent(viewport.element, Events.VIEWPORT_FIDELITY_CHANGED, eventDetail);
}
